export default __webpack_public_path__ + "static/cartaz-5a4e97e56b7ad5d804eb752c018032e8.jpg";